import { DISTRIBUTION, SINGLE_SHIPMENT } from 'modules/shipper-order/Form/constants';

/**
 * @returns {{...recurringOrder, rule_status: *, user_id: * }}
 */
export function transformShipperOrderToRecurringOrder({ status, user, ...recurringOrder }) {
  return {
    ...recurringOrder,
    rule_status: status,
    user: user,
    user_id: user?.id,
  };
}

/**
 * @returns {{...recurringOrder, shipper_order_type: (*)}}
 */
export function computeRecurringOrder({ shipper_order_type, ...recurringOrder }) {
  return {
    ...recurringOrder,
    shipper_order_type: shipper_order_type === SINGLE_SHIPMENT ? DISTRIBUTION : shipper_order_type,
  };
}
